@for (param of imageCellParams(); track param) {
  @if (param.displayData) {
    <span class="image-cell-renderer-container" [ngClass]="{'yellow-flag': param.isYellowFlag, 'project-at-risk-indicator': param.isIndicator }" [title]="!param.rendererImageFilename && param.imageTitle ? param.imageTitle : ''">
      @if (param.rendererImageFilename) {
        <svg-icon-sprite [src]="param.rendererImageFilename" viewBox="{{param.iconWidth | imageCellViewbox: param.iconHeight}}" [width]="param.iconWidth" [height]="param.iconHeight" [title]="param.imageTitle" [ngClass]="param.imageCssClass"></svg-icon-sprite>
      }
      @if (param.textCssClass) {
        <span [ngClass]="param.textCssClass">{{param.text}}</span>
      }
    </span>
  }
}
